var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"up-shop-btn"},[_c('el-switch',{on:{"change":_vm.handleChange},model:{value:(_vm.newData.value),callback:function ($$v) {_vm.$set(_vm.newData, "value", $$v)},expression:"newData.value"}}),_vm._v(" "),_c('span',{staticClass:"word"},[_vm._v(_vm._s(_vm.newData.name))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa7d1558","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/IMTable/components/tdBox/components/upShopBtn/index.vue
// module id = null
// module chunks = 